import React, { useState } from "react";
import { getEnvironmentURL } from "../../_helpers";

import { CircularProgress, Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import VehicleDetailHeaderSummaryDisplay from "./VehicleDetailHeaderSummaryDisplay";
import { utilityService } from "../../_services";

export default function VehicleDetailReturn(props) {
  const vehicle = props.item;
  const webUser = useSelector((state) => state.authentication.webUser);
  const [savingReturnReason, setSavingReturnReason] = useState(false);

  const [returnReason, setReturnReason] = useState(
    vehicle?.vehicle_return_info?.return_reason
  );
  const [carrierName, setCarrierName] = useState(
    vehicle?.vehicle_return_info?.carrier_name
  );
  const [carrierScacCode, setCarrierScacCode] = useState(
    vehicle?.vehicle_return_info?.carrier_scac_code
  );
  const [departureDate, setDepartureDate] = useState(
    vehicle?.vehicle_return_info?.departure_date
  );
  const [commodity1Origin, setCommodity1Origin] = useState(
    vehicle?.vehicle_return_info?.commodities1_origin || ""
  );

  const saveReturnReason = () => {
    setSavingReturnReason(true);
    utilityService
      .getEndpoint(`api/vehicle_return_info`, "POST", {
        body: {
          vehicle_id: vehicle.vehicleid,
          return_reason: returnReason,
          carrier_name: carrierName,
          carrier_scac_code: carrierScacCode,
          departure_date: departureDate,
          commodities1_origin: commodity1Origin
        },
      })
      .finally(() => {
        setSavingReturnReason(false);
      });
  };

  return (
    <>
      <VehicleDetailHeaderSummaryDisplay
        vehicle={{
          vin: props?.item?.vehiclevin,
          year: props?.item?.yr,
          make: props?.item?.make,
          model: props?.item?.model,
        }}
        titleStatus={props?.item?.title_status?.statusname}
        timeInLatestStatus={props?.item?.time_in_latest_status}
        latestNote={props?.item?.latest_note?.note}
      />
      <Typography variant="h5">Vehicle Return</Typography>
      <Button
        disabled={savingReturnReason}
        variant="outlined"
        color="primary"
        onClick={saveReturnReason}
      >
        Save Return Fields
      </Button>
      <Button
        disabled={savingReturnReason}
        variant="outlined"
        color="primary"
        target="_blank"
        href={`${getEnvironmentURL()}/api/vehicles/${
          vehicle.vehicleid
        }/forms/40?user_id=${webUser.userid}`}
      >
        IE Bond Request Form
      </Button>
      <Button
        disabled={savingReturnReason}
        variant="outlined"
        color="primary"
        target="_blank"
        href={`${getEnvironmentURL()}/api/vehicles/${
          vehicle.vehicleid
        }/forms/41?user_id=${webUser.userid}`}
      >
        AES Request Form
      </Button>
      {savingReturnReason && <CircularProgress size={16} />}
      <Grid container>
        <Grid item xs={12} md={3} lg={2}>
          Carrier Name (IE + AES)
        </Grid>
        <Grid item xs={12} md={9} lg={10}>
          <TextField
            rows={2}
            style={{ width: "100%" }}
            value={carrierName}
            placeholder="Carrier Name"
            onChange={(e) => setCarrierName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={2}>
          Carrier SCAC Code (IE + AES)
        </Grid>
        <Grid item xs={12} md={9} lg={10}>
          <TextField
            rows={2}
            style={{ width: "100%" }}
            value={carrierScacCode}
            placeholder="Carrier SCAC Code"
            onChange={(e) => setCarrierScacCode(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={3} lg={2}>
          Return Reason (IE)
        </Grid>
        <Grid item xs={12} md={9} lg={10}>
          <TextField
            multiline
            rows={2}
            style={{ width: "100%" }}
            value={returnReason}
            placeholder="Return Reason"
            onChange={(e) => setReturnReason(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={3} lg={2}>
          Departure Date (AES)
        </Grid>
        <Grid item xs={12} md={9} lg={10}>
          <TextField
            rows={2}
            style={{ width: "100%" }}
            value={departureDate}
            placeholder="Departure Date"
            onChange={(e) => setDepartureDate(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={3} lg={2}>
          Origin of Goods (AES)
        </Grid>
        <Grid item xs={12} md={9} lg={10}>
          <TextField
            rows={2}
            style={{ width: "100%" }}
            value={commodity1Origin}
            placeholder="Commodity Origin"
            onChange={(e) => setCommodity1Origin(e.target.value)}
          />
        </Grid>

      </Grid>
    </>
  );
}
